var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { getCommunicationChartLinkDisplayWeight } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkTrend';
import { resolveCommunicationChartLinkWeightRange } from '@web/components/CommunicationNetworkGraph/core/communicationChart/linkWidth';
import { computeCommunicationChartNodeDegrees } from '@web/components/CommunicationNetworkGraph/core/communicationChart/nodeMetrics';
import { buildCommunicationChartEdgeElements } from '@web/components/CommunicationNetworkGraph/graph/chartLayout/communicationChartEdgeElements';
import { buildCommunicationChartNodeElements } from '@web/components/CommunicationNetworkGraph/graph/chartLayout/communicationChartNodeElements';
import { applyCommunicationChartRingPositions } from '@web/components/CommunicationNetworkGraph/graph/chartLayout/communicationChartPositions';
import { usesCommunicationChartOrgTeamHubReveal } from '@web/components/CommunicationNetworkGraph/graph/communicationChartOrgTeamHubVisibility';
export { applyCommunicationChartRingPositions };
export var buildCommunicationChartElements = function (_a) {
    var data = _a.data, width = _a.width, height = _a.height, labelMaxLength = _a.labelMaxLength, nodeSizeMin = _a.nodeSizeMin, nodeSizeMax = _a.nodeSizeMax, externalNodeSize = _a.externalNodeSize, internalMeetNodeSize = _a.internalMeetNodeSize, otherNodeSize = _a.otherNodeSize, channelColors = _a.channelColors;
    var nodeIds = new Set(data.nodes.map(function (node) { return node.nodeId; }));
    var isRenderableLink = function (link) {
        return link.stats.weight > 0 &&
            nodeIds.has(link.sourceNodeId) &&
            nodeIds.has(link.targetNodeId);
    };
    var visibleRenderableLinks = data.links.filter(isRenderableLink);
    var linkWeightRange = resolveCommunicationChartLinkWeightRange(visibleRenderableLinks.map(function (link) {
        return getCommunicationChartLinkDisplayWeight(link.stats);
    }));
    var degrees = computeCommunicationChartNodeDegrees(data);
    var maxDegree = Math.max.apply(Math, __spreadArray([0], Array.from(degrees.values()), false));
    var useOrgTeamHubReveal = usesCommunicationChartOrgTeamHubReveal(data.scope);
    var nodeElements = buildCommunicationChartNodeElements({
        data: data,
        degrees: degrees,
        maxDegree: maxDegree,
        width: width,
        height: height,
        labelMaxLength: labelMaxLength,
        nodeSizeMin: nodeSizeMin,
        nodeSizeMax: nodeSizeMax,
        externalNodeSize: externalNodeSize,
        internalMeetNodeSize: internalMeetNodeSize,
        otherNodeSize: otherNodeSize
    });
    var edgeElements = buildCommunicationChartEdgeElements({
        channel: data.channel,
        links: visibleRenderableLinks,
        linkWeightRange: linkWeightRange,
        useOrgTeamHubReveal: useOrgTeamHubReveal,
        channelColors: channelColors
    });
    return {
        elements: __spreadArray(__spreadArray([], nodeElements, true), edgeElements, true)
    };
};
